import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ExportDossierFormController::__invoke
* @see app/Http/Controllers/Dossier/ExportDossierFormController.php
* @route '/api/dossier/{dossier}/export-form'
*/
const ExportDossierFormController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ExportDossierFormController.url(args, options),
    method: 'get',
})

ExportDossierFormController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/export-form',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\ExportDossierFormController::__invoke
* @see app/Http/Controllers/Dossier/ExportDossierFormController.php
* @route '/api/dossier/{dossier}/export-form'
*/
ExportDossierFormController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return ExportDossierFormController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ExportDossierFormController::__invoke
* @see app/Http/Controllers/Dossier/ExportDossierFormController.php
* @route '/api/dossier/{dossier}/export-form'
*/
ExportDossierFormController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ExportDossierFormController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\ExportDossierFormController::__invoke
* @see app/Http/Controllers/Dossier/ExportDossierFormController.php
* @route '/api/dossier/{dossier}/export-form'
*/
ExportDossierFormController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ExportDossierFormController.url(args, options),
    method: 'head',
})

export default ExportDossierFormController